<form [formGroup]="form">
    <div *ngIf="this.assistanceApplication?.isPublic && this.hasApplicantDifferences && this.showBulkAlerts"
         class="alert alert-warning mb-5 warning-width">
        <i (click)="showBulkAlerts = !showBulkAlerts" class="fa fa-times close-icon"
           style="float: right; font-size: 18px; padding: 5px;"></i>
        <div class="py-2" *ngIf="hasDifferentCounty">{{this.countyAlertMessageText}}</div>
        <div class="py-2" *ngIf="hasDifferentEmail">{{this.emailAlertMessage}}</div>
        <div class="py-2" *ngIf="hasDifferentHouseholdIncome">{{this.householdIncomeAlertMessage}}</div>
        <div class="py-2" *ngIf="hasDifferentIndividualIncome">{{this.individualIncomeAlertMessage}}</div>
    </div>
    <assistanceApplicationGroupLayout>
        Client:
        <assistanceApplicationFieldLayout>
            <label>Name:</label>
            <div class="field-max-width">{{ client?.firstName }} {{client?.middleInitial}} {{ client?.lastName }}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>SSN:</label>
            <div>{{ client?.last4Ssn ? '***-**-' + client?.last4Ssn : 'N/A' }}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Address:</label>
            <address class="field-max-width">
                {{client?.address1}} {{client?.address2}} <br>
                {{client?.city}}, {{client?.state}} {{client?.zipCode}} <br>
                {{client?.county}}
            </address>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <div class="form-check">
                <input class="form-check-input" type="checkbox"
                       id="hasDifferentDamagedDwellingAddress"
                       formControlName="hasDifferentDamagedDwellingAddress">
                <label class="form-check-label field-max-width" for="hasDifferentDamagedDwellingAddress">
                    Damaged dwelling address is different from current address
                </label>
                <div class="form-text text-muted mt-1 field-max-width">
                    Check this box if the home that was damaged by the storm is different from where you are currently living.
                </div>
            </div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label>Damaged Dwelling Address:</label>
            <div class="field-max-width"></div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label class="required-label">Address 1:</label>
            <input class="form-control"
                   [formControl]="form.get('stormApplication.damagedDwellingAddress1')"
                   placeholder="Enter address line 1">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label>Address 2:</label>
            <input class="form-control"
                   [formControl]="form.get('stormApplication.damagedDwellingAddress2')"
                   placeholder="Enter address line 2 (optional)">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label class="required-label">City:</label>
            <input class="form-control"
                   [formControl]="form.get('stormApplication.damagedDwellingCity')"
                   placeholder="Enter city">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label class="required-label">State:</label>
            <select class="form-control"
                    [formControl]="form.get('stormApplication.damagedDwellingState')">
                <option value="">Select State</option>
                <option *ngFor="let state of states" [value]="state.key">{{state.key}}</option>
            </select>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="applicationType === AssistanceApplicationType.STLStorm && hasDifferentDamagedDwellingAddress">
            <label class="required-label">Zip Code:</label>
            <input class="form-control"
                   [formControl]="form.get('stormApplication.damagedDwellingZipCode')"
                   placeholder="Enter zip code">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Household Size:</label>
            <div>{{client?.houseHoldSize ?? 'N/A'}}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Household Monthly Income:</label>
            <span [class.text-danger]="formValuesSet && form.hasError('incomeExceedsLimit')" *ngIf="hasIncome(client?.houseHoldIncome)">{{client?.houseHoldIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}</span>
            <span *ngIf="!hasIncome(client?.houseHoldIncome)" class="text-danger"> N/A</span>
            <div class="error-text mt-2 mb-2 w-100" *ngIf="hasIncomeValidationError && formValuesSet">
                <div class="m-2">The household income of {{client?.houseHoldIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}
                    is over the program maximum of {{(maxIncomeLevel$ | async) | parseNumber | currency:'USD':'symbol':'1.2-2'}}
                    for the household size of {{householdSize}} reported in this application.</div>
                <div class="m-2" *ngIf="hasHouseholdMismatch$ | async">
                    The household size from the client record ({{client?.houseHoldSize}}) doesn't match the count of adults (including the applicant) and children
                    from this application ({{householdSize}}). Inaccurate household information can affect income level validation.
                </div>
            </div>
        </assistanceApplicationFieldLayout>


        <assistanceApplicationFieldLayout>
            <label>Individual Monthly Income:</label>
            <span *ngIf="hasIncome(client?.individualMonthlyIncome)">{{client?.individualMonthlyIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}</span>
            <span *ngIf="!hasIncome(client?.individualMonthlyIncome)" class="text-danger"> N/A</span>
        </assistanceApplicationFieldLayout>

    </assistanceApplicationGroupLayout>

    <assistanceApplicationGroupLayout>
        Assigned To:
        <assistanceApplicationFieldLayout>
            <label>Agency:</label>
            <div>{{ assistanceApplication?.assignedAgency?.agencyName}}</div>
        </assistanceApplicationFieldLayout>
    </assistanceApplicationGroupLayout>

    <assistanceApplicationGroupLayout>
        Originator:
        <assistanceApplicationFieldLayout>
            <label>{{assistanceApplication?.isPublic ? 'Managed By' : 'Created By'}}:</label>
            <div>{{ user?.agency?.agencyName }}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Case Manager:</label>
            <div>{{ user?.firstName }} {{ user?.lastName }}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Phone:</label>
            <div>{{ user?.phone }}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label>Email:</label>
            <div>{{ user?.emailAddress }}</div>
        </assistanceApplicationFieldLayout>
    </assistanceApplicationGroupLayout>

    <assistanceApplicationGroupLayout>
        <label>Application:</label>

        <assistanceApplicationFieldLayout>
            <label>Type:</label>
            <div *ngIf="assistanceApplication?.isPublic; else privateApplication">
                <i class="fa fa-users me-1" aria-hidden="true"></i> Public Submission
            </div>
            <ng-template #privateApplication>
                <i class="fa fa-briefcase me-1" aria-hidden="true"></i> Agency Submission
            </ng-template>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="assistanceApplication?.isPublic">
            <label>Applicant County:</label>
            <div>
                {{assistanceApplication?.applicantCounty}}
                <i *ngIf="hasDifferentCounty" class="fa fa-exclamation-circle warning-icon"
                   (click)="openDetailAlert('', this.countyAlertMessageHtml)"></i>
            </div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                *ngIf="assistanceApplication?.isPublic && assistanceApplication?.applicantEmail">
            <label>Applicant Email:</label>
            <div>
                {{assistanceApplication?.applicantEmail}}
                <i class="fa fa-exclamation-circle warning-icon" (click)="openDetailAlert(this.emailAlertMessage, '')"
                   *ngIf="hasDifferentEmail"></i>
            </div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                [class.has-danger]="(!fundPledgeTypeId.valid && fundPledgeTypeId.touched && !fundPledgeTypeId.disabled)">
            <label class="required-label">Fund Type:</label>
            <select [formControl]="fundPledgeTypeId" class="form-control form-select">
                <option value="">Choose a Fund Type</option>
                <option *ngFor="let fundType of fundTypes"
                        [value]="fundType.id">{{fundType.name}}{{!fundType.isActive ? ' (Deactivated)' : ''}}</option>
            </select>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout>
            <label class="required-label">Total Amount Needed:</label>
            <currencyInput [control]="totalNeedControl"></currencyInput>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <label>Total Amount Requested to Date:</label>
            <div>{{stormTotalRequestedToDate | currency:'USD':'symbol':'1.2-2'}}</div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout [class.has-danger]="tierLevelControl.touched && !tierLevelControl.valid && !tierLevelControl.disabled" *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <label class="required-label">Tier Level:</label>
            <div class="ps-3">
                <div *ngFor="let tier of tierLevelOptions" class="form-check mb-3">
                    <input class="form-check-input"
                           type="radio"
                           [id]="tier.value"
                           [value]="tier.value"
                           [formControl]="tierLevelControl"
                           [disabled]="shouldBeDisabled">
                    <label class="form-check-label" [for]="tier.value">
                        <div class="fw-bold">{{ tier.label }}</div>
                        <div class="text-muted small mt-1">{{ tier.description }}</div>
                    </label>
                </div>
            </div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <label>FEMA Registration #:</label>
            <input type="text" class="form-control" [formControl]="femaRegistrationNumberControl">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout [class.has-danger]="visionLinkNumberControl.touched && !visionLinkNumberControl.valid && !visionLinkNumberControl.disabled" *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <label class="required-label">Vision Link #:</label>
            <input type="text" class="form-control" [formControl]="visionLinkNumberControl">
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="applicationType === AssistanceApplicationType.STLStorm">
            <label>Long Term Recovery Approved:</label>
            <select class="form-control" [formControl]="longTermRecoveryApprovedControl">
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
            </select>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout [class.has-danger]="summaryControl.touched && !summaryControl.valid">
            <label class="required-label">Summary:</label>
            <div *ngIf="summaryControl.touched && summaryControl.hasError('maxLength')" class="text-danger">
                {{summaryControl.getError('maxLength')}}
            </div>
            <input type="text" class="form-control" [formControl]="summaryControl" maxlength="128">
            <small class="text-muted">{{summaryControl.value?.length || 0}}/128</small>
            <p>Note: Incl. type of assistance & demographic info if desired</p>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout
                [class.has-danger]="(!descriptionControl.valid && descriptionControl.touched)">
            <label class="required-label">Circumstances:</label>
            <label *ngIf="hasTranslation" class="stacked-label" (click)="showOriginalDescription = !showOriginalDescription">
                <span>* Translated</span>
                <span>{{swapTranslationText}}</span>
            </label>
            <textarea *ngIf="!hasTranslation || showOriginalDescription" class="form-control" cols="30" rows="5" [formControl]="descriptionControl" maxlength="2048"></textarea>
            <textarea *ngIf="hasTranslation && !showOriginalDescription" class="form-control" cols="30" rows="5" formControlName="translatedDescription"></textarea>
            <small class="text-muted">{{descriptionControl.value?.length || 0}}/2048</small>
            <p>Note: If needed, drag lower right corner to expand box to show all text</p>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="applicationType === AssistanceApplicationType.STLWater">
            <label>Census Tract:</label>
            <input type="text" class="form-control" [formControl]="censusTractControl" [disabled]="true">
        </assistanceApplicationFieldLayout>

        <!-- START LOOP -->
        <assistanceApplicationFieldLayout formArrayName="companies" style="margin-top: 20px;">

            <label><i *ngIf="shouldBeDisabled && this.amountExceedsLimit()" class="fa fa-exclamation-circle warning-icon"
                      (click)="openDetailAlert(this.exceedTierMessageText, '')"></i>Payee:</label>
            <ng-container *ngFor="let company of companiesFormArray.controls; let i=index;">

                <div class="payee-container">
                    <!-- Radio Buttons Group -->
                    <div class="payee-radio-group mb-4">
                        <div [formGroupName]="i">
                            <div class="radio-container">
                                <label class="form-check me-3">
                                    <input type="radio" class="form-check-input" [value]="false"
                                           (change)="setPayeeValidators(company, false)"
                                           formControlName="useNewCompany">
                                    <span class="form-check-label">Company</span>
                                </label>
                                <label class="form-check">
                                    <input (click)="resetCompanyFormArrayMetaDataAtIndex(i)"
                                           (change)="setPayeeValidators(company, true)"
                                           type="radio" class="form-check-input" [value]="true"
                                           formControlName="useNewCompany"
                                           [checked]="getUseNewCompany(company).value">
                                    <span class="form-check-label">New Payee</span>
                                </label>
                            </div>
                        </div>
                        <button [disabled]="companiesFormArray.value.length < 2"
                                type="button"
                                class="btn btn-danger trash-button remove-icon"
                                (click)="removePayee(i)"><i class="fa fa-trash-o"></i></button>
                    </div>

                    <!-- Error Messages -->
                    <ng-container *ngIf="form.hasError('mutuallyExclusive') || form.hasError('exclusiveRequire')">
                        <span class="text-danger">{{form.getError('mutuallyExclusive')}}</span>
                        <span class="text-danger">{{form.getError('exclusiveRequire')}}</span>
                    </ng-container>

                    <!-- Company Input -->
                    <div *ngIf="!getUseNewCompany(company).value"
                         [class.has-danger]="!getCompanyName(company).valid &&
                         getCompanyName(company).touched &&
                         !getCompanyName(company).disabled">
                        <input class="form-control mb-2" type="text" [formControl]="getCompanyName(company)"
                               value="{{getCompanyName(company).value}}" placeholder="Select a Company"
                               (click)="showCompanyModal(company)"/>
                    </div>

                    <!-- New Payee Details -->
                    <fieldset *ngIf="getUseNewCompany(company).value">
                        <assistanceApplicationFieldLayout
                                [class.has-danger]="!getPayeePayeeType(company).valid &&
                            getPayeePayeeType(company).touched">
                            <label class="required-label">Payee Type:</label>
                            <div>
                                <select [formControl]="getPayeePayeeType(company)"
                                        class="form-control form-select">
                                    <option [ngValue]="null">Choose Company or Individual Payee</option>
                                    <option *ngFor="let payeeType of payeeTypesSelect"
                                            [value]="payeeType.key">{{payeeType.value}}</option>
                                </select>
                            </div>
                        </assistanceApplicationFieldLayout>

                        <assistanceApplicationFieldLayout
                                [class.has-danger]="!getPaymentTo(company).valid && getPaymentTo(company).touched">
                            <label class="required-label">Payment To:</label>
                            <input type="text" class="form-control" [formControl]="getPaymentTo(company)">
                        </assistanceApplicationFieldLayout>
                    </fieldset>

                    <!-- Address Fields for NEW PAYEE (inline) -->
                    <div class="address-fields" *ngIf="getUseNewCompany(company).value">
                            <assistanceApplicationFieldLayout
                                    [class.has-danger]="!getPayeeAddress(company).valid && getPayeeAddress(company).touched">
                                <label class="required-label">Payee Address:</label>
                                <input type="text" class="form-control" [formControl]="getPayeeAddress(company)">
                            </assistanceApplicationFieldLayout>
                            <assistanceApplicationFieldLayout
                                    [class.has-danger]="!getPayeeAddress2(company).valid && getPayeeAddress2(company).touched">
                                <label>Payee Address2:</label>
                                <input type="text" class="form-control" [formControl]="getPayeeAddress2(company)">
                            </assistanceApplicationFieldLayout>
                            <assistanceApplicationFieldLayout
                                    [class.has-danger]="!getPayeeCity(company).valid && getPayeeCity(company).touched">
                                <label class="required-label">Payee City:</label>
                                <input type="text" class="form-control" [formControl]="getPayeeCity(company)">
                            </assistanceApplicationFieldLayout>
                            <assistanceApplicationFieldLayout
                                    [class.has-danger]="!getPayeeState(company).valid && getPayeeState(company).touched">
                                <label class="required-label">Payee State:</label>
                                <select [formControl]="getPayeeState(company)" class="form-control form-select">
                                    <option value="null">Choose a State</option>
                                    <option *ngFor="let state of states"
                                            [value]="state.key">{{state.lookupValue}}</option>
                                </select>
                            </assistanceApplicationFieldLayout>
                            <assistanceApplicationFieldLayout
                                    [class.has-danger]="!getPayeeZip(company).valid && getPayeeZip(company).touched">
                                <label class="required-label">Payee Zip:</label>
                                <input type="text" class="form-control" [imask]="zipCodeMask"
                                       [formControl]="getPayeeZip(company)">
                            </assistanceApplicationFieldLayout>
                    </div>

                    <!-- Compact address display for EXISTING COMPANY -->
                    <div *ngIf="!getUseNewCompany(company).value && getCompanyOriginalId(company).value"
                         class="payee-address-line">
                        <span class="text-muted">Address: </span>
                        <span>{{ formatPayeeAddress(company) }}</span>
                        <i *ngIf="!shouldBeDisabled || denied" class="fa fa-pencil ms-1" style="cursor: pointer; color: #0a58ca;"
                           (click)="openAddressEditModal(company)"></i>
                    </div>

                    <!-- Duplicate Company Detection (new payee only) -->
                    <div *ngIf="getUseNewCompany(company).value">
                        <assistanceApplicationFieldLayout>
                            <div class="light-gray-background"
                                 *ngIf="!companyFormArrayMetaData[i]?.ignoreDuplicates && !!companyFormArrayMetaData[i]?.duplicateCompany">
                                <p class="text-danger">Duplicate Company Found:</p>
                                <div class="ms-1 p-1 m-1">
                                    <div style="font-style: italic; font-weight: bold">{{companyFormArrayMetaData[i]?.duplicateCompany?.name}}</div>
                                    <div style="font-style: italic; font-weight: bold">{{companyFormArrayMetaData[i]?.duplicateCompany?.address1}}</div>
                                </div>
                                <span class="text-danger">
                                   Use existing company?
                                   <button (click)="populateCompanyFormGroupWithExistingCompany(i)"
                                           class="ms-1 btn btn-primary btn-sm"><i
                                           class="fa fa-primary fa-check"></i></button>
                                   <button (click)="ignoreDuplicateCompany(i)" class="ms-1 btn btn-danger btn-sm"><i
                                           class="fa fa-danger fa-times"></i></button>
                                </span>
                            </div>
                        </assistanceApplicationFieldLayout>
                    </div>

                    <div class="mt-5">

                        <assistanceApplicationFieldLayout>
                            <label class="required-label">Account Number:</label>
                            <div [class.has-danger]="(!getAccountsNumber(company).valid && getAccountsNumber(company).touched)">
                                <div *ngIf="getAccountsNumber(company).touched && getAccountsNumber(company).hasError('companyAccountNumber')"
                                     class="text-danger">
                                    {{getAccountsNumber(company).getError('companyAccountNumber')}}
                                </div>
                                <input *ngIf="getAccountsNumber(company).disabled" type="text"
                                       class="form-control"
                                       readonly="readonly" [value]="getAccountsNumber(company).value">
                                <input *ngIf="!getAccountsNumber(company).disabled" type="text"
                                       class="form-control"
                                       placeholder="Account # or Payment Memo Information"
                                       [formControl]="getAccountsNumber(company)"
                                       maxlength="100"
                                       (blur)="validateAccountNumber(company)"
                                       (keyup)="validateAccountNumber(company)"
                                >
                                <div *ngIf="getAccountsNumber(company).touched && getAccountsNumber(company).hasError('accountNumberValidation')"
                                     class="text-danger">
                                    {{getAccountsNumber(company).getError('accountNumberValidation')}}
                                </div>
                                <small *ngIf="!getAccountsNumber(company).disabled" class="text-muted">
                                    {{getAccountsNumber(company).value?.length || 0}}/100
                                </small>
                            </div>
                        </assistanceApplicationFieldLayout>


                        <assistanceApplicationFieldLayout>

                            <label class="required-label">Amount:</label>

                            <div [class.has-danger]="!getPayeeAmount(company).valid && getPayeeAmount(company).touched">
                                <input class="form-control" type="number" [formControl]="getPayeeAmount(company)"
                                       value="{{getPayeeAmount(company).value}}" placeholder="Amount"/>
                            </div>
                        </assistanceApplicationFieldLayout>
                        <assistanceApplicationFieldLayout>
                            <label class="required-label">Category:</label>
                            <div [class.has-danger]="!getPayeeCategory(company).valid &&
                                getPayeeCategory(company).touched &&
                                !getPayeeCategory(company).disabled">
                                <select [formControl]="getPayeeCategory(company)" class="form-control form-select">
                                    <option value="">Choose a Category</option>
                                    <option *ngFor="let category of categoryThresholdsSelect"
                                            [value]="category.key">{{category.value}}</option>
                                </select>
                            </div>
                        </assistanceApplicationFieldLayout>
                    </div>
                    <!--                    <button *ngIf="existingCompanyDetected" (click)="removePayee(1)" class="btn btn-primary mt-3">Use Existing Company</button>-->
                    <div *ngIf="getPayeePledge(company)?.value">
                        <assistanceApplicationFieldLayout>
                            <label><a [routerLink]=" ['/app/pledge/', getPayeePledge(company)?.value]">View
                                Pledge</a></label>
                        </assistanceApplicationFieldLayout>
                    </div>
                </div>

            </ng-container>
        </assistanceApplicationFieldLayout>
        <!-- END PAYEE LOOP -->
        <assistanceApplicationFieldLayout>
            <button [disabled]="shouldBeDisabled" *ngIf="shouldAllowPayeeEdits" class="btn btn-primary pull-left" (click)="addPayee()">
                <i class="fa fa-money me-2"></i>
                Add Another Payee</button>
        </assistanceApplicationFieldLayout>
        <assistanceApplicationFieldLayout *ngIf="assistanceApplication?.fundType?.auditType.toString() === AssistanceApplicationAuditType.None">
            <label>Status:</label>
            <app-assistance-application-status [auditRequired]="isAuditRequired" [isPublic]="assistanceApplication?.isPublic"
                                               [control]="statusControl"></app-assistance-application-status>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="denied">
            <label class="required-label">Denial Reason:</label>
            <select [formControl]="denialReasonControl" class="form-control">
                <option [ngValue]="null" disabled>Choose a Denial Reason</option>
                <option *ngFor="let option of ASSISTANCE_APPLICATION_DENIAL_REASON_OPTIONS"
                        [value]="option.value">{{option.label}}</option>
            </select>
            <div class="alert alert-danger mt-2"
                 *ngIf="denialReasonControl.touched && denialReasonControl.hasError('required')">Denial reason is
                required
            </div>
        </assistanceApplicationFieldLayout>

        <assistanceApplicationFieldLayout *ngIf="denialReasonControl.value === AssistanceApplicationDenialReason.Other" [class.has-danger]="otherDenialReasonControl.touched && !otherDenialReasonControl.valid">
            <label>Explanation:</label>
            <input type="text" class="form-control" [formControl]="otherDenialReasonControl" maxlength="128">
            <small class="text-muted">{{otherDenialReasonControl.value?.length || 0}}/128</small>
        </assistanceApplicationFieldLayout>

    </assistanceApplicationGroupLayout>

    <div class="row pb-5">
        <div class="col-sm-2">
            <div>Household Information:</div>
        </div>
        <div class="col-sm-10 pt-3">
            <div *ngIf="assistanceApplication?.isPublic">
                <div><span
                        class="fw-bold">Applicant Household Income: </span>{{assistanceApplication.applicantHouseHoldIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}
                    <i *ngIf="hasDifferentHouseholdIncome" (click)="openDetailAlert(householdIncomeAlertMessage, '')"
                       style="padding-left: 5px;" class="fa fa-exclamation-circle warning-icon"></i></div>
                <div class="pt-1 pb-5"><span
                        class="fw-bold">Applicant Individual Income: </span>{{assistanceApplication.applicantIndividualMonthlyIncome | parseNumber | currency:'USD':'symbol':'1.2-2'}}
                    <i *ngIf="hasDifferentIndividualIncome" (click)="openDetailAlert(individualIncomeAlertMessage, '')"
                       style="padding-left: 5px;" class="fa fa-exclamation-circle warning-icon"></i></div>
            </div>
            <app-assistance-application-household-information-form
                    [shouldBeDisabled]="shouldBeDisabled"
                    [form]="form"
                    [minorsShouldBeRequired]="shouldRequireMinors"
                    [isBirthYearAndSsnOptional]="isBirthYearAndSsnOptional"
                    [draftId]="draftId"
            ></app-assistance-application-household-information-form>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-2">
            <div>Assistance Request Description:</div>
        </div>
        <div class="col-sm-10 pt-3">
            <label class="required-label mb-3">Please select the areas you would like to request assistance in:</label>
            <div [formGroup]="assistanceApplicationAreasOfNeedGroup">
                <div class="mt-1">
                    <div class="ps-4 pt-1 checkboxes">
                        <ng-container *ngFor="let assistanceDescription of assistanceOptions">
                            <div class="display-flex flex-row align-items-center mb-3">
                                    <input [id]="assistanceDescription.key" class="me-3" type="checkbox"
                                           [formControlName]="assistanceDescription.key">
                                <span>
                                    {{assistanceDescription.lookupValue}}
                                </span>
                            </div>
                            <div *ngIf="(assistanceDescription.key === 'uhonsRent' && assistanceApplicationAreasOfNeedGroup.get('uhonsRent').value) || (assistanceDescription.key === 'uffRentPayment' && assistanceApplicationAreasOfNeedGroup.get('uffRentPayment').value)"
                                 class="display-flex flex-row align-items-center mb-3 ps-2">
                                <span class="pe-3">
                                    Do you have notification from a court that your landlord is pursuing eviction?
                                </span>
                                <input id="evictionNotification" type="checkbox" formControlName="evictionNotification">
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-2" *ngIf="applicationType === AssistanceApplicationType.UHONS">
        <div class="col-sm-2">
            <div>Additional Resources:</div>
        </div>
        <div class="col-sm-10 pt-3">
            <label>Was the family educated about additional available programs and connected to resources beyond UHONS assistance?</label>
            <div class="ps-4 pt-3">
                <div class="form-check mb-3">
                    <input class="form-check-input" type="radio"
                           id="familyEducatedYes"
                           [value]="true"
                           [formControl]="familyEducatedAboutResourcesControl">
                    <label class="form-check-label" for="familyEducatedYes">
                        Yes. Family was educated about other resources and received direct assistance and/or referrals.
                    </label>
                </div>
                <div class="form-check mb-3">
                    <input class="form-check-input" type="radio"
                           id="familyEducatedNo"
                           [value]="false"
                           [formControl]="familyEducatedAboutResourcesControl">
                    <label class="form-check-label" for="familyEducatedNo">
                        No. No additional needs identified or no education/referrals provided.
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div style="padding-bottom: 70px;" class="row pt-2">
        <div class="col-sm-2">
            <div>Document Upload:</div>
        </div>
        <div class="col-sm-10 pt-2">
            <app-assistance-application-document-upload [areasOfNeedForm]="assistanceApplicationAreasOfNeedGroup"
                                                        [formArray]="filesFormArray"
                                                        [baseForm]="form"
                                                        [receivedForms]="assistanceApplication?.files"
                                                        [defaultOpenDocuments]="defaultOpenDocumentUpload"
                                                        (onDeleteFile)="onDeleteFile($event)"
                                                        [shouldBeDisabled]="canUploadDocuments ? false : shouldBeDisabled"
                                                        [applicationType]="applicationType"
            ></app-assistance-application-document-upload>
        </div>
    </div>

    <ng-content></ng-content>
    <company-box [availableCategories$]="categories$" (onCompanySelected)="onCompanySelected($event)"></company-box>
</form>
<div class="error-text" *ngIf="(formErrors$ | async)?.length">
    <strong>
        Some fields need your attention
    </strong>
    <span class="px-3" *ngFor="let error of formErrors$ | async">
        {{error}}
    </span>
</div>

<prompt-dialog
        [titleText]="'Client County Inactive'"
        promptText="{{clientCountyInactiveMessage}}">
</prompt-dialog>
<prompt-dialog #exceedsCategoryThreshold
               [size]="'lg'"
               [titleText]="'Payee category amounts exceed maximum allowance.'"
               [showTitle]="true"
               [allowCustomButton]="allowThresholdOverride"
               [customButtonText]="'Override and Save'"
               (customButtonEvent)="overrideSave()"
               promptText="The following is a list of entered payees and their associated category and amounts that were entered. Please verify that the values entered are within the maximum allowed amounts per category.">
    <div body>
        <app-exceeds-category-amount-threshold
                [utilityTotal]="utilityTotal"
                [rentalTotal]="rentalTotal"
                [transportationTotal]="transportationTotal"
                [childcareTotal]="childcareTotal">
        </app-exceeds-category-amount-threshold>
    </div>
</prompt-dialog>
<prompt-dialog #addressEditModal
               [size]="'md'"
               [titleText]="'Edit Payee Address'"
               [showTitle]="true"
               [overrideFooter]="true">
    <div body *ngIf="editingAddressCompany">
        <div class="form-group mb-3">
            <label>Address 1:</label>
            <input type="text" class="form-control"
                   [formControl]="getPayeeAddress(editingAddressCompany)">
        </div>
        <div class="form-group mb-3">
            <label>Address 2:</label>
            <input type="text" class="form-control"
                   [formControl]="getPayeeAddress2(editingAddressCompany)">
        </div>
        <div class="form-group mb-3">
            <label>City:</label>
            <input type="text" class="form-control"
                   [formControl]="getPayeeCity(editingAddressCompany)">
        </div>
        <div class="form-group mb-3">
            <label>State:</label>
            <select [formControl]="getPayeeState(editingAddressCompany)"
                    class="form-control form-select">
                <option value="null">Choose a State</option>
                <option *ngFor="let state of states"
                        [value]="state.key">{{state.lookupValue}}</option>
            </select>
        </div>
        <div class="form-group mb-3">
            <label>Zip Code:</label>
            <input type="text" class="form-control" [imask]="zipCodeMask"
                   [formControl]="getPayeeZip(editingAddressCompany)">
        </div>
        <div class="alert alert-info mt-3 mb-0" *ngIf="!isNewApplication">
            Address changes will not take effect until the application is saved.
        </div>
        <div class="abc-checkbox mt-3" *ngIf="canUpdateMasterAddress">
            <input type="checkbox" class="me-2" id="updateMasterAddress"
                   [(ngModel)]="updateMasterAddress" [ngModelOptions]="{standalone: true}">
            <label for="updateMasterAddress">
                {{ isSystemAdmin ? 'Update company\'s master address' : 'Request update to company\'s master address' }}
                <i class="fa fa-info-circle text-primary ms-1"
                   tooltip="Editing the address above only updates it for this application. Enabling this option will {{ isSystemAdmin ? 'update' : 'submit a request to update' }} the company's master address across the entire system."
                   placement="top"
                   container="body"></i>
            </label>
        </div>
    </div>
    <div footer>
        <button class="btn btn-primary me-2" (click)="saveAddressEdit()">Ok</button>
        <button class="btn btn-default" (click)="cancelAddressEdit()">Cancel</button>
    </div>
</prompt-dialog>

<swal #loadingDialog [allowOutsideClick]="false" [showConfirmButton]="false" [showDenyButton]="false">
    <div *swalPortal>
        <div class="row title-row mb-2">
            <h2>{{savingTitle$ | async}}</h2>
        </div>
        <div class="row w-100 py-2">
            <div class="bg-gray-lighter progress-bar w-100">
                <progress class="progress progress-bar-upload" value="100" max="100"
                          [style.width]="percentComplete$ | async"></progress>
            </div>
        </div>
        <h3>{{savingMessage$ | async}}</h3>
    </div>
</swal>
